import { render } from "./InternalPriority.vue?vue&type=template&id=51544a6a"
import script from "./InternalPriority.vue?vue&type=script&lang=js"
export * from "./InternalPriority.vue?vue&type=script&lang=js"

import "./InternalPriority.vue?vue&type=style&index=0&id=51544a6a&lan=css&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__